module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/address/postcode.js
// module id = 954
// module chunks = 0